import React from "react";

const buttons = [
  {
    mode: "metaTable",
    title: "Edit Soundtrail"
  },
  {
    mode: "HotspotSelector",
    title: "Edit Hotspots"
  }
  // {
  //   mode: "table",
  //   title: "Advanced Table Editor"
  // }
  // {
  //   mode: "help",
  //   title: "Help"
  // }
  // {
  //   mode: "code",
  //   title: "JSON"
  // }
];

export default ({ mode, setMode }) => (
  <div className="inline-flex">
    {buttons.map((button, i) => (
      <span
        key={i}
        className={`db bn pa2 outline-0 pointer black`}
        style={{ backgroundColor: mode == button.mode ? "#ff9800" : "white" }}
        onClick={() => setMode(button.mode)}
      >
        {button.title}
      </span>
    ))}
  </div>
);
